// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27mKT","fullView":"styles_fullView__3NcbJ"};